
<div>
  <VueFileAgent
     ref="fileAgent"
    :multiple="true"
    :deletable="true"
    :meta="true"
    :accept="'image/*'"
    :maxSize="'400MB'"
    :maxFiles="maxFiles"
    :helpText="selectText"
    :errorText="{
      type: errorMessage,
      size: errorSize,
    }"
    :thumbnailSize="120"
    :theme="'list'"
     v-model="fileRecords"
     @select="filesSelected($event)"
     @input="fileInput($event)"
     @upload="fileUpload($event)"
     @beforedelete="onBeforeDelete($event)"
     @delete="onDelete($event)"
  ></VueFileAgent>

  <!-- 이미지 alt 입력 // -------------------------------------------------------- -->
  <div class="pd_t10" v-if="altList.length > 0">
    <ul>
      <li v-for="(item, idx) in altList" :key="idx" class="pd_t5">
        <dt class="f_nm">{{ item.file_org_name }}</dt>
        <dd><input type="text" class="form_style" v-model="item.file_alt" placeholder="해당 이미지를 대체할 텍스트를 입력해 주세요."/></dd>
      </li>
    </ul>
  </div>
  <!-- // 이미지 alt 입력 -------------------------------------------------------- -->

</div>
